(() => {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
        (this.debouncedOnSubmit = (function (e, t) {
          let r;
          return (...t) => {
            clearTimeout(r), (r = setTimeout(() => e.apply(this, t), 500));
          };
        })((e) => {
          this.onSubmitHandler(e);
        })),
        this.querySelector("form").addEventListener(
          "input",
          this.debouncedOnSubmit.bind(this)
        );
      const e = this.querySelector("#FacetsWrapperDesktop");
      e && e.addEventListener("keyup", i);
    }
    static setListeners() {
      window.addEventListener("popstate", (t) => {
        const r = t.state ? t.state.searchParams : e.searchParamsInitial;
        r !== e.searchParamsPrev && e.renderPage(r, null, !1);
      });
    }
    static toggleActiveFacets(e = !0) {
      document.querySelectorAll(".js-facet-remove").forEach((t) => {
        t.classList.toggle("disabled", e);
      });
    }
    static renderPage(t, r, i = !0) {
      e.searchParamsPrev = t;
      const n = e.getSections(),
        a = document.getElementById("ProductCount"),
        s = document.getElementById("ProductCountDesktop");
      document
        .getElementById("ProductGridContainer")
        .querySelector(".collection")
        .classList.add("loading"),
        a && a.classList.add("loading"),
        s && s.classList.add("loading"),
        n.forEach((i) => {
          const n = `${window.location.pathname}?section_id=${i.section}&${t}`,
            a = (e) => e.url === n;
          e.filterData.some(a)
            ? e.renderSectionFromCache(a, r)
            : e.renderSectionFromFetch(n, r);
        }),
        i && e.updateURLHash(t);
    }
    static renderSectionFromFetch(t, r) {
      fetch(t)
        .then((e) => e.text())
        .then((i) => {
          const n = i;
          (e.filterData = [...e.filterData, { html: n, url: t }]),
            e.renderFilters(n, r),
            e.renderProductGridContainer(n),
            "function" == typeof initializeScrollAnimationTrigger &&
              initializeScrollAnimationTrigger(n.innerHTML);
        });
    }
    static renderSectionFromCache(t, r) {
      const i = e.filterData.find(t).html;
      e.renderFilters(i, r),
        e.renderProductGridContainer(i),
        "function" == typeof initializeScrollAnimationTrigger &&
          initializeScrollAnimationTrigger(i.innerHTML);
    }
    static renderProductGridContainer(e) {
      (document.getElementById("ProductGridContainer").innerHTML =
        new DOMParser()
          .parseFromString(e, "text/html")
          .getElementById("ProductGridContainer").innerHTML),
        document
          .getElementById("ProductGridContainer")
          .querySelectorAll(".scroll-trigger")
          .forEach((e) => {
            e.classList.add("scroll-trigger--cancel");
          });
    }
    static renderFilters(t, r) {
      const i = new DOMParser().parseFromString(t, "text/html"),
        n = i.querySelectorAll(
          "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
        ),
        a = (e) => {
          const t = r ? r.target.closest(".js-filter") : void 0;
          return !!t && e.dataset.index === t.dataset.index;
        },
        s = Array.from(n).filter((e) => !a(e)),
        c = Array.from(n).find(a);
      s.forEach((e) => {
        document.querySelector(
          `.js-filter[data-index="${e.dataset.index}"]`
        ).innerHTML = e.innerHTML;
      }),
        e.renderActiveFacets(i),
        e.renderAdditionalElements(i),
        c && e.renderCounts(c, r.target.closest(".js-filter"));
    }
    static renderActiveFacets(t) {
      [".active-facets-mobile", ".active-facets-desktop"].forEach((e) => {
        const r = t.querySelector(e);
        r && (document.querySelector(e).innerHTML = r.innerHTML);
      }),
        e.toggleActiveFacets(!1);
    }
    static renderAdditionalElements(e) {
      [".mobile-facets__open", ".mobile-facets__count"].forEach((t) => {
        e.querySelector(t) &&
          (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
      });
    }
    static renderCounts(e, t) {
      const r = t.querySelector(".facets__selected"),
        i = e.querySelector(".facets__selected"),
        n = t.querySelector(".facets__summary"),
        a = e.querySelector(".facets__summary");
      i &&
        r &&
        (t.querySelector(".facets__selected").outerHTML =
          e.querySelector(".facets__selected").outerHTML),
        n &&
          a &&
          (t.querySelector(".facets__summary").outerHTML =
            e.querySelector(".facets__summary").outerHTML);
    }
    static updateURLHash(e) {
      history.pushState(
        { searchParams: e },
        "",
        `${window.location.pathname}${e && "?".concat(e)}`
      );
    }
    static getSections() {
      return [{ section: document.getElementById("product-grid").dataset.id }];
    }
    createSearchParams(e) {
      const t = new FormData(e);
      return new URLSearchParams(t).toString();
    }
    onSubmitForm(t, r) {
      e.renderPage(t, r);
    }
    onSubmitHandler(e) {
      e.preventDefault();
      const t = document.querySelectorAll("facet-filters-form form");
      if ("mobile-facets__checkbox" == e.srcElement.className) {
        const t = this.createSearchParams(e.target.closest("form"));
        this.onSubmitForm(t, e);
      } else {
        const r = [],
          i = "FacetFiltersFormMobile" === e.target.closest("form").id;
        t.forEach((e) => {
          i
            ? "FacetFiltersFormMobile" === e.id &&
              r.push(this.createSearchParams(e))
            : ("FacetSortForm" !== e.id &&
                "FacetFiltersForm" !== e.id &&
                "FacetSortDrawerForm" !== e.id) ||
              (document
                .querySelectorAll(".no-js-list")
                .forEach((e) => e.remove()),
              r.push(this.createSearchParams(e)));
        }),
          this.onSubmitForm(r.join("&"), e);
      }
    }
    onActiveFilterClick(t) {
      t.preventDefault(), e.toggleActiveFacets();
      const r =
        -1 == t.currentTarget.href.indexOf("?")
          ? ""
          : t.currentTarget.href.slice(t.currentTarget.href.indexOf("?") + 1);
      e.renderPage(r);
    }
  }
  (e.filterData = []),
    (e.searchParamsInitial = window.location.search.slice(1)),
    (e.searchParamsPrev = window.location.search.slice(1)),
    customElements.define("facet-filters-form", e),
    e.setListeners();
  class t extends HTMLElement {
    constructor() {
      super(),
        this.querySelectorAll("input").forEach((e) =>
          e.addEventListener("change", this.onRangeChange.bind(this))
        ),
        this.setMinAndMaxValues();
    }
    onRangeChange(e) {
      this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
    }
    setMinAndMaxValues() {
      const e = this.querySelectorAll("input"),
        t = e[0],
        r = e[1];
      r.value && t.setAttribute("max", r.value),
        t.value && r.setAttribute("min", t.value),
        "" === t.value && r.setAttribute("min", 0),
        "" === r.value && t.setAttribute("max", r.getAttribute("max"));
    }
    adjustToValidValues(e) {
      const t = Number(e.value),
        r = Number(e.getAttribute("min")),
        i = Number(e.getAttribute("max"));
      t < r && (e.value = r), t > i && (e.value = i);
    }
  }
  customElements.define("price-range", t);
  class r extends HTMLElement {
    constructor() {
      super();
      const e = this.querySelector("a");
      e.setAttribute("role", "button"),
        e.addEventListener("click", this.closeFilter.bind(this)),
        e.addEventListener("keyup", (e) => {
          e.preventDefault(),
            "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
        });
    }
    closeFilter(e) {
      e.preventDefault(),
        (
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form")
        ).onActiveFilterClick(e);
    }
  }
  function i(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    const t = e.target.closest("details[open]");
    if (!t) return;
    const r = t.querySelector("summary");
    t.removeAttribute("open"), r.setAttribute("aria-expanded", !1), r.focus();
  }
  customElements.define("facet-remove", r);
})();
